import { useState } from 'react';
import { Box, Grid, Text, useTheme } from '@simplywallst/ui-core';

import { useCloudflareImage } from '@/hooks/useCloudflareImage';
import { NarrativeDisclaimerBadge } from '@/pages/Narrative/components/NarrativeDisclaimerBadge';
import { FragmentOf, gql } from '@/utilities/gql';

export const NARRATIVE_AUTHOR_FRAGMENT = gql(`
  fragment NarrativeAuthorFields on SwsAuthor @_unmask {
    displayName
    imageUrl
    name
    role
  }
`);

type Props = {
  author: FragmentOf<typeof NARRATIVE_AUTHOR_FRAGMENT>;
  userHoldsPosition: boolean | null;
};

export const NarrativeAuthor = ({ author, userHoldsPosition }: Props) => {
  const { displayName, imageUrl, name, role } = author;

  const [loaded, setLoaded] = useState(false);
  const theme = useTheme();
  const cloudflareImageSrc = useCloudflareImage({
    src: imageUrl,
    width: 64,
    height: 64,
  });

  const initials =
    displayName !== null
      ? displayName.substring(0, 2).toUpperCase()
      : name.substring(0, 2).toUpperCase();

  return (
    <Grid gap="8px" templateColumns="32px max-content" alignItems="center">
      <Box borderRadius="x4" overflow="hidden" position="relative">
        <Grid
          alignContent="center"
          justifyContent="center"
          height={theme.x4}
          width={theme.x4}
          borderRadius="x4"
          backgroundColor="darkGray"
          boxShadow="strongBorder"
        >
          <Text typography="small" textAlign="center" color="textSolid">
            {initials}
          </Text>
          <Box position="absolute" height={theme.x4} width={theme.x4}>
            <img
              style={{ visibility: loaded ? 'visible' : 'hidden' }}
              src={cloudflareImageSrc}
              onLoad={() => setLoaded(true)}
            />
          </Box>
        </Grid>
      </Box>
      <Grid>
        <Grid templateColumns="max-content min-content" gap={`${theme.x0_5}px`}>
          <Text typography="small" color="textSolid">
            {displayName || name}
          </Text>
          <NarrativeDisclaimerBadge userHoldsPosition={userHoldsPosition} />
        </Grid>
        <Text typography="tiny" color="textSofter">
          {role !== '' ? role : 'Community Contributor'}
        </Text>
      </Grid>
    </Grid>
  );
};
